/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.prepayments'},
});

const PrepaymentsItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/prepayments"
    title={messages.title}
  />
);

export default PrepaymentsItem;
